<template>
  <div class="soar-container flex flex-col gap-y-2">
    <h1 class="text-xl md:text-2xl text-primary font-medium border-b border-brand-gray-300">
      {{ $t('twoStepVerificationAndLoggedInHistory') }}
    </h1>
    <div class="w-full flex items-center text-sm md:text-base">
      <router-link
        :class="[
          matchedRoute.includes('/login-and-security/history')
            ? 'text-primary border-b-2 border-primary'
            : ''
        ]"
        class="py-0.5 md:py-2 px-1.5 md:px-3 hover:bg-brand-gray-150"
        to="/login-and-security/history"
      >
        {{ $t('loggedInHistory') }}
      </router-link>
      <div class="w-2 h-5 mb-1 border-e border-brand-gray-600"></div>
      <router-link
        :class="[
          matchedRoute.includes('/login-and-security/two-step')
            ? 'text-primary border-b-2 border-primary'
            : ''
        ]"
        class="py-0.5 md:py-2 px-1.5 md:px-3 hover:bg-brand-gray-150"
        to="/login-and-security/two-step"
      >
        {{ $t('twoStepVerification') }}
      </router-link>
    </div>

    <div class="pt-4">
      <router-view></router-view>
    </div>
  </div>
</template>

<script setup>
import client_lookups from '@/assets/json/clientLookups.json'
import { useAuthStore } from '@/stores/auth'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const matchedRoute = computed(() => route.matched.map((m) => m.path))

const authStore = useAuthStore()

const {
  application: {
    establishment,
    resident,
    citizen,
    gcc,
    gcc_citizen,
    gccNoIdentity,
    visaHolder,
    dubaiResident,
    familyMemberResidencyHolder,
    residencyCancelled
  }
} = client_lookups

const show2FATab = computed(() =>
  [
    establishment,
    resident,
    citizen,
    gcc,
    gcc_citizen,
    gccNoIdentity,
    visaHolder,
    dubaiResident,
    familyMemberResidencyHolder,
    residencyCancelled
  ].includes(authStore.user.applicationId)
)
</script>

<style lang="scss" scoped></style>
